import { render, staticRenderFns } from "./podcast-link-cmp.vue?vue&type=template&id=8f46193c&scoped=true"
import script from "./podcast-link-cmp.vue?vue&type=script&lang=js"
export * from "./podcast-link-cmp.vue?vue&type=script&lang=js"
import style0 from "./podcast-link-cmp.vue?vue&type=style&index=0&id=8f46193c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f46193c",
  null
  
)

export default component.exports